import { MuiTypographyColor, useMuiColorStyle } from "common/hooks/useMuiColor";
import { withErrorBoundary } from "portal/components/ErrorBoundary";
import React, { FunctionComponent, ReactElement } from "react";

export interface SummaryCardItemProps {
  icon: ReactElement;
  color?: MuiTypographyColor;
  text: ReactElement | string;
  actions?: ReactElement[];
  isEmpty?: boolean;
  hideEmpty?: boolean;
}

const _SummaryCardItem: FunctionComponent<SummaryCardItemProps> = ({
  icon,
  color,
  text,
  isEmpty,
  hideEmpty = false,
  actions,
}) => {
  const colorStyle = useMuiColorStyle(color);

  if (hideEmpty && isEmpty) {
    return;
  }
  return (
    <li className="flex gap-2 min-h-5 items-center" style={colorStyle}>
      <div className="flex w-6 flex-shrink-0 items-center justify-center">
        {icon}
      </div>
      <span className="flex-1 whitespace-nowrap overflow-ellipsis overflow-hidden">
        {text}
      </span>
      {actions && <div className="flex-shrink-0">{actions}</div>}
    </li>
  );
};

export const SummaryCardItem = withErrorBoundary(
  { i18nKey: "components.robots.RobotSummary.failedShort", small: true },
  _SummaryCardItem
);
